import * as api from '../api';
import { errorUtilities, guidUtilities } from '../common';
import * as setupConstants from './portal-setup-constants';

export const createUserActions = api.fetchActions('portal-setup', 'create-user');

export const actionTypes = {
  ...createUserActions.actionTypes,
  UPDATE_VALUE : 'portal-setup.update-value',
  UPDATE_VALIDATION : 'portal-setup.update-validation',
  SHOW_VALIDATION : 'portal-setup.show-add-validation',
}

export function createUser() {
  return (dispatch, getState) => {
    const state = getState();
    const { portalSetup } = state;
    const { value } = portalSetup;
    return dispatch(api.postThunk(`/setup/eto-create`, value, createUserActions));
  }
}

export function updateValue(path, value) {
  return {
    type : actionTypes.UPDATE_VALUE,
    path,
    value
  }
}

function requiredResponseError(source, errorNum) {
  return errorUtilities.validationError(source, 'required', 'setup', errorNum, "Element requires a response");
};

export function validateForm() {
  return (dispatch, getState) => {
    const state = getState();
    const { portalSetup } = state;
    const { value } = portalSetup;
    var errors = [];

    var url = value && value.get(setupConstants.urlSection)
    var assetId = value && value.get(setupConstants.assetIdSection)
    var enterpriseGuid = value && value.get(setupConstants.enterpriseSection)
    var numParticipants = value && value.get(setupConstants.participantsSection)
    var apiUserId = value && value.get(setupConstants.apiUserSection)

    if(!url) {
      errors.push(requiredResponseError(setupConstants.urlSection, errors.length));
    }

    if(!assetId) {
      errors.push(requiredResponseError(setupConstants.assetIdSection, errors.length));
    }

    if(!enterpriseGuid) {
      errors.push(requiredResponseError(setupConstants.enterpriseSection, errors.length));
    }
    else if(!guidUtilities.isValidGuid(enterpriseGuid)) {
      errors.push(errorUtilities.validationError(setupConstants.enterpriseSection,
        'invalid-guid', 'setup', errors.length, "Please enter a valid Guid, xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx", errorUtilities.errorTypes.inline));
    }

    if(!apiUserId) {
      errors.push(requiredResponseError(setupConstants.apiUserSection, errors.length));
    }

    return dispatch(setValidationResult(errors));
  }
}

function setValidationResult(value) {
  return {
    type : actionTypes.UPDATE_VALIDATION,
    value
  }
}

export function showValidation() {
  return {
    type : actionTypes.SHOW_VALIDATION
  }
}



// WEBPACK FOOTER //
// src/portal-setup/portal-setup.actions.js